import { L10N } from '../Rates.l10n';

export const getClubInclude = ({ discount, rate } = {}) =>
  discount ? L10N.LABEL_MEMBER_DISCOUNT : rate ? L10N.LABEL_MEMBER_EXCLUSIVE : undefined;
